import React, { useRef } from "react";
import { Box } from "@curves/ui-base";
import UploadBox from "@icoach/components/UploadBox";

const UploadStreamTestPage = props => {
	const uploadFileRef = useRef(null);

	// 上傳請假證明 事件
	const handleFileChange = ({ file }) => {
		if (file) uploadFileRef.current = file;
	};

	return (
		<Box className="main-container-spacing p-4">
			<UploadBox title="測試"  onFileChange={handleFileChange} />
		</Box>
	);
};

export default UploadStreamTestPage;
